var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleStore = function SvgGoogleStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleStore_svg__a)",
    d: "M.822.369a1.39 1.39 0 0 0-.32.971v15.322c-.02.352.095.7.32.971l.053.053L9.455 9.1v-.204L.874.316z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleStore_svg__b)",
    d: "M12.316 11.962 9.454 9.1v-.204l2.862-2.856.064.035 3.391 1.926c.972.546.972 1.448 0 2l-3.39 1.926z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleStore_svg__c)",
    d: "M12.38 11.927 9.472 9.019l-8.65 8.614a1.164 1.164 0 0 0 1.425.04l10.116-5.746"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#googleStore_svg__d)",
    d: "M12.38 6.075 2.247.322A1.123 1.123 0 0 0 .822.37l8.632 8.632z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.316 11.863 2.247 17.575a1.163 1.163 0 0 1-1.39 0l-.052.053.052.052a1.163 1.163 0 0 0 1.39 0l10.116-5.747z",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.822 17.54a1.413 1.413 0 0 1-.32-.977v.099c-.019.352.095.7.32.971l.053-.052zM15.771 9.897l-3.455 1.966.064.064 3.391-1.949a1.227 1.227 0 0 0 .727-1 1.286 1.286 0 0 1-.727.919",
    opacity: 0.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.247.427 15.772 8.1a1.279 1.279 0 0 1 .727.901 1.216 1.216 0 0 0-.727-1L2.246.322C1.294-.224.502.23.502 1.34v.1c0-1.106.792-1.565 1.745-1.013",
    opacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleStore_svg__a",
    x1: 8.698,
    x2: -2.93,
    y1: 1.178,
    y2: 12.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleStore_svg__b",
    x1: 15.888,
    x2: -0.876,
    y1: 9.001,
    y2: 9.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleStore_svg__c",
    x1: 10.792,
    x2: -4.971,
    y1: 10.589,
    y2: 26.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "googleStore_svg__d",
    x1: -1.353,
    x2: 5.691,
    y1: -4.732,
    y2: 2.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2D9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15BD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06D575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DE76"
  })))));
};
export default SvgGoogleStore;